import type { FaireProductEntity } from "../../entity_types/product";

export const p_b67hq84shq: FaireProductEntity = {
  token: "p_b67hq84shq",
  type: "product",
  name: "LAKEWOOD JUICE PNEAPLE PURE ORG",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/7603bf78b0a7ade843b64817cf06e76efd02369d6c3939626c6177977e600900.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ae7a486873070bf303e77584116aa9321258915f99fd21d37f993a6f06fbc51.jpeg",
    "https://cdn.faire.com/fastly/d092942c4f7e1da877557161966245d102af9d7514c7ed3a9deafca466fe24a7.jpeg",
  ],
  priceDollars: 23.07,
  description:
    "Created from a family recipe in 1935, Lakewood Juices are made from the freshest fruit and vegetables available. Lakewood Organic Pineapple Juice is made from freshly pressed pineapples and bottled without preservatives or added sugar. Health-conscious customers seeking a refreshing drink with a tropical flavor, Lakewood Organic Pineapple Juice is the ideal choice.",
  tags: [],
  msrpDollars: 79.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:06.476Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
